export default __webpack_public_path__ + "static/media/carousel2.8d5bddf3.jpg";